import firebase from 'firebase/app'
import { db, auth } from '../../../firebase'

const actions = {
    async signUpWithGoogle({ commit }) {
        var provider = new firebase.auth.GoogleAuthProvider()

        auth
        .signInWithPopup(provider)
        .then((result) => {
            /** @type {firebase.auth.OAuthCredential} */
            var credential = result.credential

            // This gives you a Google Access Token. You can use it to access the Google API.
            var token = credential.accessToken
            // The signed-in user info.
            var user = result.user
            var userId  = user.uid
            
            var accountRef = db
                .collection('users')
                .doc(userId)

            accountRef.get().then(async function(doc) {
                if(doc.exists) {
                    let account = doc.data()
                    account.activity.lastOnlineDate = new Date()

                    let roles = account.roles
                    let slug = account.slug
                    commit('setUser', { userId, slug, roles })
                    
                    db
                        .collection('users')
                        .doc(userId)
                        .update(account)
                } else {
                    // Generate tags for search by name
                    let nameArray = user.displayName.toLowerCase().split(' ')
                    let nameTags = []

                    for(let i = 0; i < nameArray.length; i++) {
                        for(let j = 2; j < nameArray[i].length + 1; j++) {
                            nameTags.push(nameArray[i].substring(0, j))
                        }
                    }
                    nameTags.push(user.displayName.toLowerCase())

                    let inititalAccount = {
                        activity: {
                            lastOnlineDate: new Date(),
                            lastCommentDate: new Date(1994, 1),
                        },
                        name: user.displayName,
                        nameTags: nameTags,
                        slug: user.displayName
                            .replace(/[^a-zA-Z0-9 ]/g, '')
                            .replace(/\s+/g, '-')
                            .toLowerCase(),
                        avatar: user.photoURL,
                        cover: '',
                        intro: '',
                        instagram: '',
                        website: '',
                        roles: ['visitor','artist']
                    }

                    db
                        .collection('users')
                        .doc(userId)
                        .set(inititalAccount)

                    let initialUsers = {
                        users: []
                    }
                    
                    await db
                        .collection('users')
                        .doc(userId)
                        .collection('social')
                        .doc('following')
                        .set(initialUsers)
                    
                    await db
                        .collection('users')
                        .doc(userId)
                        .collection('social')
                        .doc('followers')
                        .set(initialUsers)

                    let roles = inititalAccount.roles
                    let slug = inititalAccount.slug
                    commit('setUser', { userId, slug, roles })
                }
            }).catch(function(error) {
                console.log("Error getting document: ", error)
            })
        }).catch((error) => {
            var errorCode = error.code
            var errorMessage = error.message

            console.log(errorCode + ": " + errorMessage)
            // The email of the user's account used.
            var email = error.email
            // The firebase.auth.AuthCredential type that was used.
            var credential = error.credential
            // ...
        })
    },

    async signupUser({ commit }, { email, password, username }) {
        var userId = null
        var slug = username
            .replace(/[^a-zA-Z0-9 ]/g, '')
            .replace(/\s+/g, '-')
            .toLowerCase()

        const userRef = await db
            .collection('users')
            .where('slug', '==', slug)
            .get()

        if(!userRef.empty) {
            return 'slug-exists'
        } else {
            await auth
            .createUserWithEmailAndPassword(email, password)
            .then((userCredential) => {
                // Signed in
                userId = userCredential.user.uid

                var accountRef = db
                    .collection('users')
                    .doc(userId)

                accountRef.get().then(async function(doc) {
                    if(doc.exists) {
                        alert('User doc already exists.')
                        return 'user-exists'
                    } else {
                        // Generate tags for search by name
                        let nameArray = username.toLowerCase().split(' ')
                        let nameTags = []

                        for(let i = 0; i < nameArray.length; i++) {
                            for(let j = 2; j < nameArray[i].length + 1; j++) {
                                nameTags.push(nameArray[i].substring(0, j))
                            }
                        }
                        nameTags.push(username.toLowerCase())

                        let inititalAccount = {
                            activity: {
                                lastOnlineDate: new Date(),
                                lastCommentDate: new Date(1994, 1),
                            },
                            name: username,
                            nameTags: nameTags,
                            newsletter: ['beta'],
                            slug: slug,
                            email: email,
                            avatar: '',
                            cover: '',
                            intro: '',
                            instagram: '',
                            website: '',
                            roles: ['visitor','artist']
                        }

                        try {
                            await db
                                .collection('users')
                                .doc(userId)
                                .set(inititalAccount)
                        } catch(error) {
                            throw error
                        }

                        let initialUsers = {
                            users: []
                        }
                        
                        await db
                            .collection('users')
                            .doc(userId)
                            .collection('social')
                            .doc('following')
                            .set(initialUsers)
                        
                        await db
                            .collection('users')
                            .doc(userId)
                            .collection('social')
                            .doc('followers')
                            .set(initialUsers)

                        let roles = inititalAccount.roles
                        commit('setUser', { userId, slug, roles })
                    }
                })
            })
            .catch((error) => {
                return error
            })
        }
    },
    
    async loginUser({ commit }, { email, password }) {
        return auth
        .signInWithEmailAndPassword(email, password)
        .then(authenticationData => {
            var userId  = authenticationData.user.uid
            
            var accountRef = db
                .collection('users')
                .doc(userId)

            accountRef.get().then(function(doc) {
                if (doc.exists) {
                    let account = doc.data()
                    account.activity.lastOnlineDate = new Date()

                    let roles = account.roles
                    let slug = account.slug
                    commit('setUser', { userId, slug, roles })
                    
                    db
                        .collection('users')
                        .doc(userId)
                        .update(account)
                } else {
                    // huge error, user doc for the firebase user should always exist
                }
            }).catch(function(error) {
                console.log('Error getting document: ', error)
            })
        })
        .catch((error) => {
            return error
        })
    },
    
    
    async logoutUser({ commit }) {
        try {
            await auth.signOut()
            
            let user = {
                id:   null,
                slug: null,
                roles: ['visitor']
            }

            commit('setUser', user)
        } catch(error) {
            throw error
        }
    },


    async sendPasswordReset() {
        var email = auth.currentUser.email

        try {
            await auth.sendPasswordResetEmail(email)
            console.log('Password reset email sent to:' + email)
        } catch(error) {
            throw error
        }
    },


    async sendPasswordResetEmail({ commit }, { email }) {
        try {
            await auth.sendPasswordResetEmail(email)
            console.log('Password reset email sent to:' + email)
        } catch(error) {
            throw error
        }
    }
}

export default actions